import { render } from "./guanyuwomeng.vue?vue&type=template&id=16951acf"
import script from "./guanyuwomeng.vue?vue&type=script&lang=js"
export * from "./guanyuwomeng.vue?vue&type=script&lang=js"

import "./guanyuwomeng.vue?vue&type=style&index=0&id=16951acf&lang=css"

import exportComponent from "/Users/a123/Documents/HBuilderProjects/limit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__